import { createStore } from "vuex";
import data from "@/assets/data.json";

export default createStore({
  state: {
    entries: data.entries,
  },
  getters: {
    getEntryBySlug: (state) => (slug) => {
      return state.entries.find((entry) => entry.slug === slug);
    },
    getEntriesByYear: (state) => (entryYear) => {
      console.log(entryYear, "entryYear in state");
      return state.entries.filter((entry) => entry.year === entryYear);
    },
  },
  mutations: {},
  actions: {},
  modules: {},
});
